<ul>
  @for (breadcrumb of breadcrumbs; track breadcrumb) {
    <li>
      @if (breadcrumb.url) {
        <span>
          <a routerLink="/{{breadcrumb.url}}" [queryParams]="breadcrumb.queryParams" [id]="breadcrumb.url" (click)="breadcrumb.click ? breadcrumb.click() : null">{{breadcrumb.label.key | translate}}</a>
          <i style="margin: 0 5px;">/</i>
        </span>
      }
      @if (!breadcrumb.url) {
        <span>{{ breadcrumb.label.value ? breadcrumb.label.value : (breadcrumb.label.key | translate)}}</span>
      }
    </li>
  }
</ul>